// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activityBlock__TH2Ps {
  height: calc(100vh - 150px);
  padding-left: 1px;
  overflow: hidden;
}
@media (max-width: 1300px) {
  .activityBlock__TH2Ps {
    height: 100%;
  }
}
@media print {
  .activityBlock__TH2Ps {
    height: auto;
    overflow: visible;
  }
}

.blockHead__wUoOy {
  min-height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blockTitle__Nb_Xt {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__T5fkf {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  height: calc(100% - 93px);
  min-height: 150px;
  padding: 25px 0 25px 25px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--table-box-shadow);
}
@media print {
  .blockContainer__T5fkf {
    height: auto;
    padding: 0;
    background-color: transparent;
    box-shadow: none;
  }
}

.activityForm__zZ43U {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  column-gap: 8px;
  width: 100%;
  padding-right: 25px;
  position: relative;
}
.activityForm__zZ43U div[role=application] {
  border: 1px solid var(--inputs-default-stroke) !important;
  overflow-y: hidden !important;
}
.activityForm__zZ43U iframe {
  background: var(--inputs-default-surface-default) !important;
}
.activityForm__zZ43U iframe .mce-content-body__qXQzK {
  color: var(--inputs-default-text) !important;
}
@media print {
  .activityForm__zZ43U {
    overflow: hidden;
    height: 0;
  }
}

.activityFormWrapper__rAMpP {
  width: 100%;
}
.activityFormWrapper__rAMpP .editorWrapper__Ka8fT .tox-edit-area__iframe__xxHlA {
  border: 1px solid var(--Inputs-default-stroke) !important;
  background: var(--Inputs-default-surface-default) !important;
}

@media print {
  .activityFormAttaches__eAh6K {
    overflow: hidden;
    height: 0;
  }
}

.commentSendBlock__Y86ul {
  position: absolute;
  top: 10px;
  right: 80px;
  width: 15px;
  display: flex;
  align-items: flex-end;
}

.commentsWrapper__osvij {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  height: 100%;
  max-height: calc(100vh - 335px);
  padding-right: 24px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}
.commentsWrapper__osvij::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.commentsWrapper__osvij::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.commentsWrapper__osvij::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.commentsWrapper__osvij::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 1299.99px) {
  .commentsWrapper__osvij {
    max-height: none;
  }
}
@media print {
  .commentsWrapper__osvij {
    height: auto;
    max-height: unset;
    overflow: visible;
  }
}

.emptyCommentBlock__xyUBL {
  position: absolute;
  top: 20px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  padding-right: 25px;
}

.emptyCommentBlockText__tEleB {
  font-family: Roboto;
  font-size: 12px;
  text-transform: uppercase;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
}

.sendIconBtn__V5y7M {
  cursor: pointer;
}

.active__Lj41K > path {
  fill: var(--buttons-surface);
}

.disabled__dRHB9 {
  pointer-events: none;
  opacity: 0.7;
}

.loader__IgLQf {
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
}

.blockWthtBtns__Xt1Wv {
  height: calc(100% - 35px);
}

.skeletonForm__yq1YM {
  height: 34px;
}

.skeletonAvatarIcon___c2_M {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.skeletonComment__pGSw4 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.skeletonCommentTitle__JtPov {
  height: 20px;
  width: 40%;
}

.skeletonCommentHeadWrapper__om84P {
  display: flex;
  gap: 10px;
}

.skeletonCommentText__KWaRy {
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/Activity/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,2BAAA;EACA,iBAAA;EACA,gBAAA;AAzEF;AA2EE;EALF;IAMI,YAAA;EAxEF;AACF;AA0EE;EATF;IAUI,YAAA;IACA,iBAAA;EAvEF;AACF;;AA0EA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAvEF;;AA0EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAvEF;;AA0EA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qDAAA;EACA,mCAAA;AAvEF;AAyEE;EAVF;IAWI,YAAA;IACA,UAAA;IACA,6BAAA;IACA,gBAAA;EAtEF;AACF;;AAyEA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAtEF;AAwEE;EACE,yDAAA;EACA,6BAAA;AAtEJ;AAyEE;EACE,4DAAA;AAvEJ;AAyEI;EACE,4CAAA;AAvEN;AA2EE;EAtBF;IAuBI,gBAAA;IACA,SAAA;EAxEF;AACF;;AA2EA;EACE,WAAA;AAxEF;AA0EE;EACE,yDAAA;EACA,4DAAA;AAxEJ;;AA6EE;EADF;IAEI,gBAAA;IACA,SAAA;EAzEF;AACF;;AA4EA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAzEF;AAvFE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAyFJ;AAtFE;EACE,+BAAA;EACA,kBAAA;AAwFJ;AArFE;EACE,8BAAA;EACA,kBAAA;AAuFJ;AApFE;EACE,gBAAA;EACA,kBAAA;AAsFJ;AA4DE;EAbF;IAcI,gBAAA;EAzDF;AACF;AA2DE;EAjBF;IAkBI,YAAA;IACA,iBAAA;IACA,iBAAA;EAxDF;AACF;;AA2DA;EACE,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AAxDF;;AA2DA;EACE,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,iDAAA;EACA,kBAAA;AAxDF;;AA2DA;EACE,eAAA;AAxDF;;AA4DE;EACE,4BAAA;AAzDJ;;AA6DA;EACE,oBAAA;EACA,YAAA;AA1DF;;AA6DA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA1DF;;AA6DA;EACE,yBAAA;AA1DF;;AA6DA;EACE,YAAA;AA1DF;;AA6DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA1DF;;AA6DA;EACE,YAAA;EACA,UAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,SAAA;AA1DF;;AA6DA;EACE,YAAA;AA1DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.activityBlock {\n  height: calc(100vh - 150px);\n  padding-left: 1px;\n  overflow: hidden;\n\n  @media (max-width: 1300px) {\n    height: 100%;\n  }\n\n  @media print {\n    height: auto;\n    overflow: visible;\n  }\n}\n\n.blockHead {\n  min-height: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n  height: calc(100% - 93px);\n  min-height: 150px;\n  padding: 25px 0 25px 25px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--table-box-shadow);\n\n  @media print {\n    height: auto;\n    padding: 0;\n    background-color: transparent;\n    box-shadow: none;\n  }\n}\n\n.activityForm {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  column-gap: 8px;\n  width: 100%;\n  padding-right: 25px;\n  position: relative;\n\n  div[role='application'] {\n    border: 1px solid var(--inputs-default-stroke) !important;\n    overflow-y: hidden !important ;\n  }\n\n  iframe {\n    background: var(--inputs-default-surface-default) !important;\n\n    .mce-content-body {\n      color: var(--inputs-default-text) !important;\n    }\n  }\n\n  @media print {\n    overflow: hidden;\n    height: 0;\n  }\n}\n\n.activityFormWrapper {\n  width: 100%;\n\n  .editorWrapper .tox-edit-area__iframe {\n    border: 1px solid var(--Inputs-default-stroke) !important;\n    background: var(--Inputs-default-surface-default) !important;\n  }\n}\n\n.activityFormAttaches {\n  @media print {\n    overflow: hidden;\n    height: 0;\n  }\n}\n\n.commentSendBlock {\n  position: absolute;\n  top: 10px;\n  right: 80px;\n  width: 15px;\n  display: flex;\n  align-items: flex-end;\n}\n\n.commentsWrapper {\n  display: flex;\n  flex-direction: column;\n  row-gap: 20px;\n  height: 100%;\n  max-height: calc(100vh - 335px);\n  padding-right: 24px;\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  @include scrollBar;\n\n  @media (max-width: 1299.99px) {\n    max-height: none;\n  }\n\n  @media print {\n    height: auto;\n    max-height: unset;\n    overflow: visible;\n  }\n}\n\n.emptyCommentBlock {\n  position: absolute;\n  top: 20px;\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n  text-align: center;\n  padding-right: 25px;\n}\n\n.emptyCommentBlockText {\n  font-family: Roboto;\n  font-size: 12px;\n  text-transform: uppercase;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n}\n\n.sendIconBtn {\n  cursor: pointer;\n}\n\n.active {\n  & > path {\n    fill: var(--buttons-surface);\n  }\n}\n\n.disabled {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.loader {\n  height: 100%;\n  display: grid;\n  justify-content: center;\n  align-items: center;\n}\n\n.blockWthtBtns {\n  height: calc(100% - 35px);\n}\n\n.skeletonForm {\n  height: 34px;\n}\n\n.skeletonAvatarIcon {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n\n.skeletonComment {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.skeletonCommentTitle {\n  height: 20px;\n  width: 40%;\n}\n\n.skeletonCommentHeadWrapper {\n  display: flex;\n  gap: 10px;\n}\n\n.skeletonCommentText {\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activityBlock": `activityBlock__TH2Ps`,
	"blockHead": `blockHead__wUoOy`,
	"blockTitle": `blockTitle__Nb_Xt`,
	"blockContainer": `blockContainer__T5fkf`,
	"activityForm": `activityForm__zZ43U`,
	"mceContentBody": `mce-content-body__qXQzK`,
	"activityFormWrapper": `activityFormWrapper__rAMpP`,
	"editorWrapper": `editorWrapper__Ka8fT`,
	"toxEditAreaIframe": `tox-edit-area__iframe__xxHlA`,
	"activityFormAttaches": `activityFormAttaches__eAh6K`,
	"commentSendBlock": `commentSendBlock__Y86ul`,
	"commentsWrapper": `commentsWrapper__osvij`,
	"emptyCommentBlock": `emptyCommentBlock__xyUBL`,
	"emptyCommentBlockText": `emptyCommentBlockText__tEleB`,
	"sendIconBtn": `sendIconBtn__V5y7M`,
	"active": `active__Lj41K`,
	"disabled": `disabled__dRHB9`,
	"loader": `loader__IgLQf`,
	"blockWthtBtns": `blockWthtBtns__Xt1Wv`,
	"skeletonForm": `skeletonForm__yq1YM`,
	"skeletonAvatarIcon": `skeletonAvatarIcon___c2_M`,
	"skeletonComment": `skeletonComment__pGSw4`,
	"skeletonCommentTitle": `skeletonCommentTitle__JtPov`,
	"skeletonCommentHeadWrapper": `skeletonCommentHeadWrapper__om84P`,
	"skeletonCommentText": `skeletonCommentText__KWaRy`
};
module.exports = ___CSS_LOADER_EXPORT___;
